// Entegrasyon Ekle penceresi (pazaryeri / yemek / kargo) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.addIntegration';

export const addIntegrationModalGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Entegrasyon nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Bu pencereyle bir pazaryeri, yemek sipariş platformu veya kargo firması hesabınızı sisteme bağlarsınız. Girilen anahtarlar yanlışsa siparişler ve stok bilgisi aktarılamaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.trendyol`, 'Trendyol'),
    t(`${G}.nav.n11`, 'N11'),
    t(`${G}.nav.hepsiburada`, 'Hepsiburada'),
    t(`${G}.nav.more`, '…'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Pazaryeri / Yemek / Kargo Entegrasyonu Ekle'),
    tabs: t(`${G}.regions.tabs`, 'Platform sekmeleri'),
    body: t(`${G}.regions.body`, 'Genel Ayarlar ve API Bilgileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Platformu seçin'),
      text: t(`${G}.s1.text`, 'Pencere, açtığınız bölüme göre sekmeleri gösterir. Pazaryeri: Trendyol, N11, Hepsiburada, Amazon, Pazarama, PttAVM. Yemek: Yemeksepeti, Getir Food, Migros Food, Uber Eats. Kargo: HepsiJet, DHL (MNG). Bir pencerede tek kayıt eklenir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sekme değiştirince o ana kadar yazdığınız alanlar temizlenir; önceki platformun bilgileri yeni kayda taşınmaz.'),
        t(`${G}.s1.tip2`, '"Entegrasyonu Etkinleştir" anahtarı varsayılan olarak açıktır; kapalı kaydederseniz entegrasyon pasif olarak eklenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Pazaryeri: API bilgilerini girin'),
      text: t(`${G}.s2.text`, 'API Key ve API Secret zorunludur. Trendyol, Hepsiburada ve Amazon\'da Seller ID de zorunludur. Hepsiburada\'da yalnız Secret Key ve MerchantId (Mağaza ID) istenir. Pazarama\'da Client ID ve Client Secret, PttAVM\'de Api-Key ve Access-Token girilir. Bu bilgileri ilgili platformun satıcı panelinden alın; Trendyol için menü yolu pencerede yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Aynı pazaryerini ikinci kez eklerseniz yeni kayıt açılmaz; mevcut kaydın anahtarları yenileriyle güncellenir.'),
        t(`${G}.s2.tip2`, 'Gizli alanları göz simgesiyle görünür yapıp yazdığınızı kontrol edebilirsiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Yemek platformu: şube ve mağaza adı'),
      text: t(`${G}.s3.text`, 'Şube Seç ve Mağaza / Marka Adı (en fazla 150 karakter) zorunludur; entegrasyon seçtiğiniz şubeye bağlanır. Ardından platformun kimlik bilgilerini girin: Yemeksepeti için Remote ID ve Chain Code; Getir Food için Restaurant ID, App Secret Key ve Restaurant Secret Key; Migros Food için Restaurant ID (Store ID), XApiKey ve Chain ID; Uber Eats için Tedarikçi ID, Mağaza ID, API Key ve API Secret.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aynı şubede aynı platformdan birden fazla marka varsa her birini ayrı mağaza adıyla ekleyin. O şubede zaten tanımlı mağazalar mavi kutuda listelenir.'),
        t(`${G}.s3.tip2`, 'Aynı şube ve aynı mağaza adıyla tekrar kaydederseniz mevcut kayıt güncellenir. Mağaza kimliği başka bir kayıtta kullanılıyorsa kayıt reddedilir.'),
        t(`${G}.s3.tip3`, 'Şube listesi boşsa önce bir şube tanımlayın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Kargo: hesap ve gönderici bilgileri'),
      text: t(`${G}.s4.text`, 'HepsiJet: Kullanıcı Adı ve Şifre ile birlikte Gönderici / Firma Bilgileri bölümündeki Firma Adı, Firma Kısa Kodu, Gönderici Adres ID, XDock Kısa Kodu, İl, İlçe ve Açık Adres zorunludur (Mahalle / Semt isteğe bağlı). Bu değerleri HepsiJet entegrasyon ekibinden alıp birebir girin. DHL (MNG): önce Test Ortamı (Sandbox) seçimini yapın; Apizone API Anahtarı ve Güvenlik Dizgisi, MNG Müşteri No ve MNG Şifre ile Gönderici Firma Adı, Telefon, İl, İlçe ve Açık Adres zorunludur.'),
      tips: [
        t(`${G}.s4.tip1`, 'MNG\'de API Adresi test ortamı seçimine göre kendiliğinden belirlenir. Daha önce kaydedilmiş bir güvenlik dizgisi varsa alanı boş bırakabilirsiniz; mevcut değer korunur.'),
        t(`${G}.s4.tip2`, 'Gönderici adresi kargo etiketi ve gönderi oluşturmak için kullanılır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" eksik alan varsa kırmızı uyarıda alanın adını yazar. Kayıt başarılı olunca yeşil mesaj çıkar ve pencere kendiliğinden kapanır; yeni entegrasyon listede görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Bu pencerede bağlantı testi yoktur. Kaydettikten sonra listede entegrasyonu Düzenle ile açıp "Bağlantıyı Test Et" düğmesini kullanın.'),
      ],
    },
  ],
});
